// removed by extract-text-webpack-plugin
module.exports = {"expandBtn":"_178EET1tPz-eaEgLKnDKD5","isExpand":"_1jnyeb0IrNqvbIqlyXZr5H"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExpandButton/ExpandButton.css
// module id = 176
// module chunks = 0